import { Navigate, useParams } from "react-router-dom";
import { getCity } from "../data/cities";
import { getService } from "../data/services";
import { paths } from "../i18n";

// Maps legacy 1stnation-security.com slugs to this site's new URL scheme
const LEGACY_SERVICE_MAP = {
  "uniformed-security-guards": "security-guards",
  "security-guard-services": "security-guards",
  "k9-security": "security-guards",
  "airport-transit-security": "security-guards",
  "indigenous-community-security": "security-guards",
  "mobile-patrol-security": "mobile-patrol",
  "mobile-patrol": "mobile-patrol",
  "event-security": "event-security",
  "event-security-services": "event-security",
  "construction-site-security": "construction-site-security",
  "construction-security": "construction-site-security",
  "concierge-security": "concierge-front-desk",
  "concierge-front-desk-security": "concierge-front-desk",
  "loss-prevention": "loss-prevention",
  "retail-loss-prevention": "loss-prevention",
  "retail-security": "retail-security",
  "alarm-response": "alarm-response",
  "alarm-response-services": "alarm-response",
  "industrial-security": "industrial-security",
  "healthcare-security": "hospital-security",
  "hospital-security": "hospital-security",
  "campus-security": "school-security",
  "school-security": "school-security",
  "fire-watch-services": "fire-watch",
  "fire-watch": "fire-watch",
  "executive-protection": "executive-protection",
  "parking-enforcement": "parking-enforcement"
};

export default function LegacyRedirect({ lang, kind }) {
  const { svc, city } = useParams();
  const p = paths(lang);
  const citySlug = city ? city.replace(/\/+$/, "") : null;
  const cityExists = citySlug ? !!getCity(citySlug) : false;

  if (kind === "city") {
    return <Navigate to={cityExists ? p.city(citySlug) : p.cities} replace />;
  }
  const newSvc = LEGACY_SERVICE_MAP[svc] || (getService(svc) ? svc : null);
  if (!newSvc) return <Navigate to={p.services} replace />;
  if (kind === "combo") {
    return <Navigate to={cityExists ? p.combo(newSvc, citySlug) : p.service(newSvc)} replace />;
  }
  return <Navigate to={p.service(newSvc)} replace />;
}
